import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/coaching/directory')({
  component: () => <PageStub title="Coach Directory" description="Find a coach or expert" />,
});
